export enum RoomDetailsMountComponent {
  HotelViewRoomsSection = `hotelViewRoomsSection`,
  RoomDetailsOverlay = `roomDetailsOverlay`
}
